import { getCachedCountries } from "../../../../../Utils/phoneCountriesCache"

// Logo constraints (§11.8): PNG only, exactly 320x320, max 10 MB.
export const LOGO_MIME = "image/png"
export const LOGO_DIMENSION_PX = 320
export const MAX_LOGO_BYTES = 10 * 1024 * 1024

// Reads a File's pixel dimensions via an offscreen Image element — no upload
// involved, so this works with the externalOps stub exactly as it will with a
// real one.
export const readImageDimensions = (file) =>
  new Promise((resolve) => {
    const objectUrl = URL.createObjectURL(file)
    const img = new Image()
    img.onload = () => {
      resolve({ width: img.naturalWidth, height: img.naturalHeight })
      URL.revokeObjectURL(objectUrl)
    }
    img.onerror = () => {
      resolve(null)
      URL.revokeObjectURL(objectUrl)
    }
    img.src = objectUrl
  })

// Default the phone country to the merchant's locale region until they pick one
// (copied from Recover Configure).
const detectRegion = () => {
  const loc = (navigator.languages && navigator.languages[0]) || navigator.language || ""
  try {
    return new Intl.Locale(loc).region || (loc.split("-")[1] || "").toUpperCase() || null
  } catch {
    return (loc.split("-")[1] || "").toUpperCase() || null
  }
}

export const countryByIsoCode = (isoCode) => {
  if (!isoCode) return null
  const match = (getCachedCountries() || []).find(
    (c) => (c.country_code || "").toUpperCase() === String(isoCode).toUpperCase()
  )
  return match
    ? { code: match.code, countryCode: match.country_code, name: match.name, id: match.id }
    : null
}

export const defaultPhoneCountry = () => countryByIsoCode(detectRegion())
